import { Form as SemanticForm } from "semantic-ui-react";
import { Checkbox } from "../Checkbox";
import { FormInput } from "./FormInput";
import { LegacyFormRadio } from "./LegacyFormRadio";

export const Form = (props) => <SemanticForm {...props} />;

Form.Field = SemanticForm.Field;
Form.Button = SemanticForm.Button;
Form.Checkbox = Checkbox;
Form.Dropdown = SemanticForm.Dropdown;
Form.Group = SemanticForm.Group;
Form.Select = SemanticForm.Select;
Form.TextArea = SemanticForm.TextArea;
Form.Radio = LegacyFormRadio;
Form.Input = FormInput;
